import PropTypes from 'prop-types';

import './styles/panelStyles.css';

const Panel = ({ children, ...rest }) => (
  <div className="panel p-4" {...rest}>
    {children}
  </div>
);

Panel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Panel;
